
import { Image } from "@atoms";

export type OnboardCardTemplateProps = {
  title: string;
  description: string;
  icon: JSX.Element;
  onClick: () => void;
  index: number;
  isSectionIncomplete: boolean;
  completionLabel?: string;
};

export const OnboardCardTemplate = ({
  title,
  icon,
  onClick,
  index,
  isSectionIncomplete,
  completionLabel
}: OnboardCardTemplateProps): JSX.Element => {
  const isDisabled = !isSectionIncomplete;
  const hoverClasses = isDisabled
    ? "cursor-default"
    : "hover:border-primary-medium hover:scale-105 cursor-pointer";

  return (
    <button
      type="button"
      onClick={isDisabled ? undefined : onClick}
      style={{ height: 240 }}
      className={`relative flex flex-col text-center pt-3 pl-3 pb-3 pr-3 h-full bg-white border border-neutral-light rounded-3xl transition ease-in-out delay-0 duration-200 transform scale-100 ${hoverClasses}`}
    >
      <div className="flex-col items-start justify-between h-auto max-w-min">
        <div className="absolute top-[13px] left-[13px] z-50 flex items-center">
          <div className="font-bold text-md border-0 m-2 p-5 w-4 h-4 rounded-3xl bg-gray-50 flex justify-center items-center">
            {index + 1}
          </div>
        </div>
        <div className="h-full">
          <div className="relative overflow-hidden rounded-lg">
            <div className="">{icon}</div>
            {completionLabel ? (
              <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                <div className="px-2 py-2 text-md font-semibold text-black bg-white border border-neutral-light rounded-md leading-none">
                  {completionLabel}
                </div>
              </div>
            ) : null}
          </div>
          <div className="text-left w-full">
            <h5 className="my-3 w-11/12 font-medium text-base leading-5 text-neutral-darkest">{title}</h5>
          </div>
        </div>
        {/* {isSectionIncomplete ?
          <div>
            <div className="flex flex-row text-left items-center h-6 pb-2">
              <h4 className="font-medium text-base pr-1">Start</h4>
              <Image variant={"rightArrow"} />
            </div>
          </div>
        :
          <div>
            <div className="flex flex-row justify-end items-center h-6 pb-2">
              <div className="flex font-semibold text-xs text-successful-darkest px-3 pt-2 h-8 bg-successful-lightest rounded-full align-self-center justify-content-center">
                Completed
              </div>
            </div>  
          </div>
        } */}
      </div>
    </button>
  );
};
